(ns practitest.frontend.users-view.utils
  (:require [practitest.frontend.common.i18n :refer [get-translation]]))

(def table-id "users-view-index")

(def selection-path [:users-view :users-view-index])

(def pat-states ["disabled" "enabled" "enabled_with_impersonation"])

(defn pat-state-label [pat-state]
  (case pat-state
    "disabled" (get-translation "generic.label.disabled" "Disabled")
    "enabled" (get-translation "generic.label.enabled" "Enabled")
    "enabled_with_impersonation" (get-translation "users-view.pat-state.enabled-with-impersonation" "Enabled with Impersonation")
    pat-state))

(defn pat-label->state [label]
  (or (some #(when (= label (pat-state-label %)) %) pat-states)
      label))
